import { createPortal, useFrame } from '@react-three/fiber'
import { useGLTF, Text, Decal, useFBO, Wireframe } from '@react-three/drei'
import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'
import { useRef, useMemo, useLayoutEffect, useEffect } from 'react'
import { fonts } from '../../fonts'
import * as THREE from 'three'

const RaceNumber = ({ model, coords }) => {
  const snap = useSnapshot(state.current)
  const { nodes, materials } = useGLTF(model)
  const meshRef = useRef()

  // console.log(coords)
  const { camW, camH, fboWidth, fboHeight, decalScale } = useMemo(() => {
    const [arW, arH] = coords.aspectRatio
    const camW = 0.9
    const camH = camW * (arH / arW)
    const fboWidth = 4096
    const fboHeight = Math.round(fboWidth * (arH / arW))

    const decalScale = [
      coords.decalSize * (arW > arH ? arW / arH : 1),
      coords.decalSize * (arH > arW ? arH / arW : 1),
      coords.decalSize * 0.5
    ]


    return { camW, camH, fboWidth, fboHeight, decalScale }
  }, [coords.aspectRatio, coords.decalSize])

  const textScene = useMemo(() => new THREE.Scene(), [])
  const textCamera = useMemo(() => {
    const cam = new THREE.OrthographicCamera(-camW, camW, camH, -camH, 0.1, 10)
    cam.position.z = 5
    return cam
  }, [camW, camH])

  const fbo = useFBO(fboWidth, fboHeight, { samples: 8 })
  fbo.texture.minFilter = THREE.LinearMipmapLinearFilter
  fbo.texture.magFilter = THREE.LinearFilter
  fbo.texture.generateMipmaps = true

  useFrame(({ gl }) => {
    gl.setRenderTarget(fbo)
    gl.setClearColor(0x000000, 0)
    gl.clear()
    gl.render(textScene, textCamera)
    gl.setRenderTarget(null)
  })

  useLayoutEffect(() => {
    nodes.RaceNumber.geometry.computeBoundingBox()
    const size = new THREE.Vector3()
    nodes.RaceNumber.geometry.boundingBox.getSize(size)
    console.log('Mesh size:', size)
  }, [nodes])

  useEffect(() => {
    if (meshRef.current) {
      console.log('mesh world pos:', meshRef.current.getWorldPosition(new THREE.Vector3()))
      console.log('mesh world rotation:', meshRef.current.getWorldQuaternion(new THREE.Quaternion()))
    }
  }, [])

  // const letterSpacing = useMemo(() => {
  //   const number = snap.choices.raceNumber.selected.number
  //   const ones = number.split('').filter(c => c === '1').length
  //   return Math.max(0.05, 0.1 - ones * 0.05)
  // }, [snap.choices.raceNumber.selected.number])

  if (state.current.choices.raceNumber.selected.mode === 'none') return null

  const [tx, ty, tz] = coords.textPosition

  const textProps = {
    font: fonts["helvetica"],
    anchorX: 'center',
    anchorY: 'middle',
    scale: [coords.textScale, coords.textScale, coords.textScale],
    fontWeight: coords.fontWeight || 400,
    letterSpacing: coords.letterSpacing,

  }

  // console.log(coords.textRotation)
  return (
    <>
      {createPortal(
        <>
          <Text
            position={[tx, ty, tz]}
            outlineWidth={0.11}
            outlineColor={snap.choices.raceNumber.selected.outlineHex}
            // outlineColor="#5b982d"
            outlineBlur={0}
            fillOpacity={0}
            sdfGlyphSize={128}
            // material-metalness={1}
            // material-roughness={0.25}
            // material-envMapIntensity={2}
            // material-toneMapped={false}
            {...textProps}
          >
            {snap.choices.raceNumber.selected.number}
            {/* <meshStandardMaterial
              color={snap.choices.raceNumber.selected.outlineHex}
              metalness={1}
              roughness={0.01}
              envMapIntensity={2}
            /> */}
          </Text>
          <Text
            position={[tx, ty, tz + 0.0002]}
            color={snap.choices.raceNumber.selected.hex}
            {...textProps}
          >
            {snap.choices.raceNumber.selected.number}
          </Text>
        </>,
        textScene
      )}

      <group dispose={null}>
        <mesh
          ref={meshRef}
          geometry={nodes.RaceNumber.geometry}
          material={materials.RaceNumber}
          rotation={coords.modelRotation}
          position={coords.modelPosition}
          polygonOffset
          polygonOffsetFactor={2}
          material-transparent={true}
          material-opacity={0}
          material-depthWrite={false}

        >
          {/* <Wireframe /> */}
          <Decal
            // debug
            position={[0, 0, 0]}
            rotation={coords.textRotation}
            scale={decalScale}
          >
            <meshBasicMaterial
              map={fbo.texture}
              transparent
              depthTest={false}
              polygonOffset
              polygonOffsetFactor={-1}
            />
          </Decal>
        </mesh>
      </group>
    </>
  )
}

export default RaceNumber